import React from "react";
// Import the core content component
import SpectateTableContent from "./SpectateTableContent";

// Import dedicated CSS (used by SpectateTableContent)
import "./SpectateGamesDashboard.css";

// This component is rendered for NON-AUTHENTICATED users (no ProtectedLayout/Nav Bar)
function SpectateGamesDashboard() {
  return (
    <div className="games-dashboard-wrapper">
      <SpectateTableContent />
    </div>
  );
}

export default SpectateGamesDashboard;
